export interface Props {
    text: string;
}

export const IAQuestion = ({ text }: Props) => {
  return (
    <div className="ai-chat__bubble">
        <div className="ai-chat__bubble-avatar">
        <i className="icon icon-sys-user"></i>
        </div>
        <div className="ai-chat__bubble-txt">
        <p>{ text }</p>
        </div>
    </div>
  )
}